/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * BoostrackApi - interface
 * 
 * @export
 * @interface BoostrackApiInterface
 */
export interface BoostrackApiInterface {
    /**
     * 
     * @summary Send a ping to boostrack api, which returns a timestamp on success
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoostrackApiInterface
     */
    pingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Send a ping to boostrack api, which returns a timestamp on success
     */
    ping(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

}

/**
 * 
 */
export class BoostrackApi extends runtime.BaseAPI implements BoostrackApiInterface {

    /**
     * Send a ping to boostrack api, which returns a timestamp on success
     */
    async pingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/boostrack/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send a ping to boostrack api, which returns a timestamp on success
     */
    async ping(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.pingRaw(initOverrides);
        return await response.value();
    }

}
